import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Video from "../../components/video-js";
import Image from "../../elements/image";
import Icon from "../../elements/icon";
import BasicModal from "../../elements/basic-modal";

const VideoCard = ({
  heading,
  label,
  learnMoreTitle,
  backgroundImage,
  video,
  modalProps
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const modalClassNames = classNames(
    "card-modal",
    `${isModalOpen ? "show" : "hide"}-basic-modal`
  );

  useEffect(() => {
    return function cleanup() {
      document.body.classList.remove("show-modal");
    };
  });

  return (
    <>
      <div
        className="card__content"
        onClick={() => {
          setIsModalOpen(true);
          document.body.classList.add("show-modal");
        }}
      >
        <Image {...backgroundImage}></Image>
        <div className="card__overlay"></div>
        <div className="card__overlay-content">
          <span className="card__learn-more-title">{learnMoreTitle}</span>
        </div>
        <div className="card__play-icon">
          <Icon className="icon--outline" name="PlayButtonOutline" />
          <Icon className="icon--fill" name="PlayButtonFill" />
        </div>
        <div className="card__bottom-row">
          <div className="card__title-wrapper">
            <span className="card__label">{label}</span>
            <span className="card__heading">{heading}</span>
          </div>
        </div>
      </div>
      <BasicModal
        {...modalProps}
        onCloseClicked={() => {
          setIsModalOpen(false);
          document.body.classList.remove("show-modal");
        }}
        className={modalClassNames}
      >
        {isModalOpen && <Video {...video} forcePlay />}
      </BasicModal>
    </>
  );
};

VideoCard.propTypes = {
  heading: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  learnMoreTitle: PropTypes.string.isRequired,
  backgroundImage: PropTypes.shape(Image.propTypes).isRequired,
  video: PropTypes.shape(Video.propTypes).isRequired,
  modalProps: PropTypes.shape({
    withShadow: PropTypes.bool,
    screenSettings: {
      fullWidth: PropTypes.bool,
      fullScreen: PropTypes.bool,
      fullHeight: PropTypes.bool
    }
  })
};

VideoCard.defaultProps = {
  modalProps: {
    withShadow: true,
    screenSettings: {
      fullWidth: false,
      fullScreen: false,
      fullHeight: false
    }
  }
};

export default VideoCard;
